// only applies for first time
// need revision if enforce password change happens again
// true: password not changed; enforce date passsed -> redirect to change password page
// false: password not changed; enforce date not passed -> show popup
// undefined: password changed -> nothing happens
export const shouldPasswordUpdateEnforced = (user, enforcedDate, // 'YYYY-MM-DD'
serverTime) => {
    if (user.passwordUpdatedAt)
        return undefined;
    const enforcedDateTime = new Date(enforcedDate + 'T00:00:00');
    const now = serverTime ? new Date(serverTime) : new Date();
    return now.getTime() > enforcedDateTime.getTime();
};
